import React from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";
import "./footer.css";

function Footer() {
  return (
    <div className="footer">
      <MDBFooter className=" footer_clr page-footer font-small lighten-5 pt-0">
        <div style={{ backgroundColor: "#21d192" }}>
          <MDBContainer>
            <MDBRow className="py-4 d-flex align-items-center">
              <MDBCol
                md="6"
                lg="5"
                className="text-center text-md-left mb-4 mb-md-0"
              >
                <h6 className="mb-0 white-text">Get connected with us !</h6>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </div>
        <MDBContainer className="mt-5 mb-4 text-center text-md-left">
          <MDBRow className="mt-3">
            <MDBCol md="3" lg="4" xl="3" className="mb-4 dark-grey-text">
              <h6 className="text-uppercase font-weight-bold">
                <strong> e-temp</strong>
              </h6>
              <hr
                className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                style={{ width: "60px" }}
              />
              <p>Here you can use buy, unlimited cloths for man & woman.</p>
              <p> With Best Products 💹💹💹 </p>
            </MDBCol>
            <MDBCol
              md="2"
              lg="2"
              xl="1"
              className="mb-4 dark-grey-text txt_al "
            >
              <br />
              <p>
                <a
                  href="/shop"
                  style={{ textDecoration: "none" }}
                  className="text-muted"
                >
                  Shop
                </a>
              </p>
              <p>
                <a
                  href="/about"
                  style={{ textDecoration: "none" }}
                  className="text-muted"
                >
                  About us
                </a>
              </p>
              <p>
                <a
                  href="/faq"
                  style={{ textDecoration: "none" }}
                  className="text-muted"
                >
                  F.A.Q.
                </a>
              </p>
              <p>
                <a
                  href="/contact"
                  style={{ textDecoration: "none" }}
                  className="text-muted"
                >
                  Contact
                </a>
              </p>
            </MDBCol>
            <MDBCol md="3" lg="2" xl="5" className="mb-4 dark-grey-text">
              <h6 className="text-uppercase font-weight-bold">
                <strong>Top Category</strong>
              </h6>
              <hr
                className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                style={{ width: "60px" }}
              />
              <p>
                <a
                  href="/Man"
                  className="dark-grey-text"
                  style={{
                    textDecoration: "none",
                    color: "purple",
                    fontWeight: "bold",
                  }}
                >
                  Man
                </a>
              </p>
              <p>
                <a
                  href="/Woman"
                  className="dark-grey-text"
                  style={{
                    textDecoration: "none",
                    color: "purple",
                    fontWeight: "bold",
                  }}
                >
                  Woman
                </a>
              </p>
            </MDBCol>
            <MDBCol md="4" lg="3" xl="3" className="mb-4 dark-grey-text">
              <h6 className="text-uppercase font-weight-bold">
                <strong>Contact</strong>
              </h6>
              <hr
                className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                style={{ width: "60px" }}
              />
              <p>
                <i className="fa fa-home mr-3" /> New York, NY 10012, US
              </p>
              <p>
                <i className="fa fa-envelope mr-3" /> info@example.com
              </p>
              <p>
                <i className="fa fa-phone mr-3" /> + 01 234 567 88
              </p>
              <p>
                <i className="fa fa-print mr-3" /> + 01 234 567 89
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        <div
          className="footer-copyright text-center py-3"
          style={{ backgroundColor: "gray" }}
        >
          <MDBContainer fluid>
            &copy; {new Date().getFullYear()} Copyright:
            <b>www.etemp.com</b>
          </MDBContainer>
        </div>
      </MDBFooter>
    </div>
  );
}

export default Footer;
